import type { LucideIcon } from "lucide-react";
import { Handshake, Heart, Leaf, Shield, Target } from "lucide-react";

export const ABOUT_VALUE_ICON_IDS = [
  "heart",
  "shield",
  "handshake",
  "target",
  "leaf",
] as const;

export type AboutValueIconId = (typeof ABOUT_VALUE_ICON_IDS)[number];

export const ABOUT_VALUE_ICON_OPTIONS: Array<{
  id: AboutValueIconId;
  label: string;
  Icon: LucideIcon;
}> = [
  { id: "heart", label: "Heart", Icon: Heart },
  { id: "shield", label: "Shield", Icon: Shield },
  { id: "handshake", label: "Handshake", Icon: Handshake },
  { id: "target", label: "Target", Icon: Target },
  { id: "leaf", label: "Leaf", Icon: Leaf },
];

const ICON_MAP: Record<AboutValueIconId, LucideIcon> = {
  heart: Heart,
  shield: Shield,
  handshake: Handshake,
  target: Target,
  leaf: Leaf,
};

export function normalizeAboutValueIcon(icon: string | undefined | null): AboutValueIconId {
  const trimmed = (icon ?? "").trim().toLowerCase();
  if ((ABOUT_VALUE_ICON_IDS as readonly string[]).includes(trimmed)) {
    return trimmed as AboutValueIconId;
  }
  return "heart";
}

export function resolveAboutValueIcon(icon: string | undefined | null): LucideIcon {
  return ICON_MAP[normalizeAboutValueIcon(icon)];
}
